import React, { useState } from "react";
import "./productReview.scss";
// import Reviews from "../../../components/reviews/Reviews";
import {
  Box,
  Button,
  Grid,
  LinearProgress,
  Rating,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  useMediaQuery,
} from "@mui/material";
// icon
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import CloseIcon from "@mui/icons-material/Close";
import ReviewSkeleton from "../../../../components/reviews/ReviewSkeleton";
import { useEffect } from "react";
import ReviewsNew from "../../../../components/reviews/ReviewsNew";

const ProductReview = ({
  isLoading,
  ratings,
  totalReview,
  averageRating,
  particularRatings,
  appBarColor = "#1976d2",
}) => {
  const maxWidth_600 = useMediaQuery("(max-width:600px)");

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [particularRating, setParticularRating] = useState([
    {
      id: 1,
      name: "5 Star",
      value: 0,
      reviewCount: particularRatings.fiveStar,
    },
    {
      id: 2,
      name: "4 Star",
      value: 0,
      reviewCount: particularRatings.fourStar,
    },
    {
      id: 3,
      name: "3 Star",
      value: 0,
      reviewCount: particularRatings.threeStar,
    },
    { id: 4, name: "2 Star", value: 0, reviewCount: particularRatings.twoStar },
    { id: 5, name: "1 Star", value: 0, reviewCount: particularRatings.oneStar },
  ]);

  useEffect(() => {
    setParticularRating([
      { id: 1, name: "5 Star", reviewCount: particularRatings.fiveStar },
      { id: 2, name: "4 Star", reviewCount: particularRatings.fourStar },
      { id: 3, name: "3 Star", reviewCount: particularRatings.threeStar },
      { id: 4, name: "2 Star", reviewCount: particularRatings.twoStar },
      { id: 5, name: "1 Star", reviewCount: particularRatings.oneStar },
    ]);
  }, [particularRatings]);

  return (
    <div className="productReview">
      <p className="rating-title">Ratings</p>
      <Grid container className="reviews">
        <Grid item container className="overview">
          <Grid
            item
            xs={12}
            md={6}
            sx={{ border: "1px solid hsl(220, 10%, 94%)" }}
            className="average-rating"
          >
            <h3>Average rating</h3>
            <h1>{averageRating.toFixed(1)}/5</h1>
            <Rating
              name="read-only"
              value={parseInt(averageRating.toFixed(1))}
              readOnly
              precision={0.1}
              sx={{ fontSize: "23px" }}
              icon={<StarRoundedIcon fontSize="inherit" />}
              emptyIcon={<StarRoundedIcon fontSize="inherit" />}
            />
            <p>
              (
              {ratings.length > 0 && Object.keys(ratings[0]).length === 0
                ? 0
                : totalReview > 999
                  ? (totalReview / 1000).toFixed(2) + "k"
                  : totalReview}{" "}
              reviews)
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ border: "1px solid hsl(220, 10%, 94%)" }}
            className="particular-rating"
          >
            {particularRating &&
              particularRating.map((item) => (
                <Box className="single-rating" key={item.id}>
                  <p className="star">{item.name}</p>
                  <LinearProgress
                    variant="determinate"
                    value={(item.reviewCount / totalReview) * 100 || 0}
                    className="linear-progress"
                  />
                  <p>
                    {item.reviewCount > 999
                      ? (item.reviewCount / 1000).toFixed(2) + "k"
                      : item.reviewCount}
                  </p>
                </Box>
              ))}
          </Grid>
        </Grid>
        <Grid item container className="reviews-container">
          <div className="customer-ratings-title">Customer Rating</div>
          {isLoading ? (
            <ReviewSkeleton />
          ) : totalReview !== 0 &&
            ratings?.length > 0 &&
            Object.keys(ratings[0]).length !== 0 ? (
            <>
              {ratings
                .slice(0, 4)
                .reverse()
                .map((item) => {
                  return <ReviewsNew key={item._id} item={item} />;
                })}
              <Dialog
                fullScreen={maxWidth_600 ? true : false}
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="lg"
                // TransitionComponent={Transition}
              >
                <AppBar sx={{ position: "sticky", bgcolor: appBarColor }}>
                  <Toolbar>
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={handleClose}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Toolbar>
                </AppBar>
                {ratings
                  .slice(0)
                  .reverse()
                  .map((item) => {
                    return <ReviewsNew key={item._id} item={item} />;
                  })}
              </Dialog>
              {totalReview > 4 && (
                <Button
                  sx={{ m: 1, color: "var(--blackColor)" }}
                  onClick={handleClickOpen}
                >
                  View All
                </Button>
              )}
            </>
          ) : (
            <div className="no-customer-rating">
              <p>No Customer Rating</p>
            </div>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ProductReview;
